/* eslint-disable react/prop-types */ // TODO: add props
import Numpad from '../keypads/Numpad';
import CursorControls from '../keypads/CursorControls';
import Operators from '../keypads/Operators';

const BaseLayout = ({ onKeyPressWrite, onTriggerKeystroke }) => (
  <div className="keypad-layout base">
    <div className="left">
      <Numpad onKeyPressWrite={onKeyPressWrite} />
      <CursorControls onKeyPressWrite={onTriggerKeystroke} />
    </div>
    <Operators onKeyPressWrite={onKeyPressWrite} />
  </div>
);

export default BaseLayout;
